import React from "react";
import { BillingService } from "@services/BillingService";
import { useFetch } from "@hooks/useFetch";
import { DataTable } from "@components";
import { InvoiceTableColumns } from "./components/InvoiceTableColumns";
import { InvoiceTableExpandContent } from "./components/InvoiceTableExpandContent";
import { NextUpcomingInvoiceWidget } from "./components/NextUpcomingInvoiceWidget";


/**
 * Billing Page
 * ------------
 * This page displays the next upcoming payment and previous payment for the distributor.
 */

export const BillingPage: React.FC = () => {
  
  const billingService = new BillingService();
  const { data: invoices, isLoading: isLoadingInvoices } = useFetch(
    billingService.getInvoices,
    [],
    []
  );

  const nextUpcomingInvoice = invoices && invoices.length > 0 ? invoices[0] : undefined;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Billing</h1>
      </div>

      <div className="mb-6">
        <NextUpcomingInvoiceWidget
          invoice={nextUpcomingInvoice}
          isLoading={isLoadingInvoices}
        />
      </div>

      <DataTable
        columns={InvoiceTableColumns()}
        data={(invoices || []).slice(1)} 
        isLoading={isLoadingInvoices}
        enableExpansion={true}
        expandableRowRenderer={(invoice) => (
          <InvoiceTableExpandContent invoice={invoice} />
        )}
        getRowCanExpand={() => true}
        title="Previous Invoices"
        description="Click on a row to view monthly breakdown"
      />
    </div>
  );
};

